<script setup>
defineProps({
  task: {
    type: Object,
    required: true,
  },
  disable: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['toggle'])
</script>

<template>
  <div @click.stop>
    <q-checkbox
      :model-value="task.completed"
      dense
      :disable="disable"
      @update:model-value="emit('toggle', task)"
    />
  </div>
</template>
